const setVendor = (vendor) => {
    return {
        type: 'SET_VENDOR',
        data: vendor
    }
}

module.exports = {
    setVendor
}